type Ticket = {
    start: () => void;
    /** Handle of the not-yet-started turn, so giving it up again can call it off. */
    timer: number;
    started: boolean;
}

const waiting: Ticket[] = [];
let active: Ticket | null = null;

const grantNext = () => {
    if (active !== null) {
        return;
    }
    const next = waiting.shift();
    if (next === undefined) {
        return;
    }
    active = next;
    // A fresh macrotask on purpose: the offline resolvers hold the main thread for the whole
    // query, so handing the turn over through the task queue is what gives the browser the
    // chance to paint what the previous turn produced.
    next.timer = window.setTimeout(() => {
        next.started = true;
        next.start();
    }, 0);
};

/**
 * Lets callers take turns instead of all running at once. `start` is invoked once the previous
 * turn has been given up; the returned callback gives this turn up in return (and takes the
 * caller out of the queue, or calls its turn off again, if it never got to run).
 */
export const takeQueryTurn = (start: () => void): (() => void) => {
    const ticket: Ticket = { start, timer: 0, started: false };
    waiting.push(ticket);
    grantNext();

    return () => {
        if (active === ticket) {
            if (!ticket.started) {
                window.clearTimeout(ticket.timer);
            }
            active = null;
            grantNext();
            return;
        }
        const index = waiting.indexOf(ticket);
        if (index !== -1) {
            waiting.splice(index, 1);
        }
    };
};
